<script lang="ts">
    import { _ } from "svelte-i18n"
    import MagnifyIcon from "svelte-material-icons/Magnify.svelte"
    import { colorGroup1, colorCodes } from "../../config"
    import { langField } from "../../i18n"
    import ProductSummary from "./ProductSummary.svelte"

    export let callback: Function
    export let product: Product
    export let activeColor: RALColor = undefined
    export let activeOptions: string[] = []
    $: quboMatt = product.code.toString().match(/^23/) ? " matt" : ""

    let colors: RALColor[] = []

    let search: string = ""
    $: if (search) {
        colors = colorCodes.filter((c) => {
            if (
                c.RAL.includes(search.replace(/\s*RAL*/, "")) ||
                langField(c, "").toLowerCase().includes(search.toLowerCase())
            ) {
                return true
            }
        })
    } else {
        colors = colorCodes
    }
</script>

<div class="content">
    <ProductSummary product="{product}" color="{activeColor}" options="{activeOptions}" />
    <h3>{$_("product.choose-color")}</h3>
    <p>
        {@html $_("product.choose-color-intro-html")}
    </p>
    <div class="search">
        <input type="text" name="search" placeholder="{$_('product.search-color')}" bind:value="{search}" />
        <div class="icon">
            <MagnifyIcon size="24px" />
        </div>
    </div>
    {#if !search}
        <h3>{$_("product.colors-with-preview")}</h3>
        <div class="colors group1">
            {#each colorGroup1 as c}
                <div
                    class="item"
                    class:active="{activeColor?.RAL == c.RAL}"
                    on:click="{() => {
                        activeColor = c
                        callback(c)
                    }}"
                >
                    <div class="color" style="background:{c.HEX};"></div>
                    <div class="title">RAL {c.RAL}</div>
                    <div class="subtitle">{langField(c, "")}{quboMatt}</div>
                </div>
            {/each}
        </div>
    {/if}
    <h3>{$_("product.colors-without-preview")}</h3>
    <div class="colors">
        {#each colors as c}
            <div
                class="item"
                class:active="{activeColor?.RAL == c.RAL}"
                on:click="{() => {
                    activeColor = c
                    callback(c)
                }}"
            >
                <div class="color" style="background:{c.HEX};"></div>
                <div class="title">RAL {c.RAL}</div>
                <div class="subtitle">{langField(c, "")}{quboMatt}</div>
            </div>
        {/each}
    </div>
</div>

<style lang="less">
    @import "../../css/variables.less";

    .content {
        padding: 20px;
    }
    h3 {
        margin: 0px;
        margin-bottom: 20px;
    }
    .search {
        margin-bottom: 30px;
        width: 100%;
        position: relative;
        overflow: hidden;
        .border-radius(5px);
        input {
            font-size: 1rem;
            border: 1px solid var(--border-color-default);
            .border-radius(5px);
            height: 45px;
            padding: 0px 50px 0px 15px;
            width: 100%;
            &:focus {
                .border-radius(5px);
                outline: none;
                border-color: var(--primary);
            }
        }
        .icon {
            transition: all 0.3s;
            position: absolute;
            right: 0;
            top: 0;
            bottom: 0;
            width: 50px;
            cursor: pointer;
            .flex();
            align-items: center;
            justify-content: center;
            &:hover {
                background: var(--primary);
                color: var(--on-primary);
            }
        }
    }

    h3 {
        font-size: 1rem;
    }
    .colors {
        .flex();
        flex-wrap: wrap;
        margin: 0px -2%;
        &.group1 {
            margin-bottom: 30px;
        }
        .item {
            transition: all 0.3s;
            cursor: pointer;
            padding: 10px;
            width: 21%;
            margin: 2%;
            border: solid 3px transparent;
            @media (min-width: 1300px) and (max-width: 1860px) {
                width: 29%;
            }
            @media (max-width: 1024px) {
                width: 16%;
            }
            @media (max-width: 850px) {
                width: 21%;
            }
            @media (max-width: 620px) {
                width: 29%;
            }
            @media (min-width: 1024px) {
                &:hover {
                    background: var(--background);
                }
            }
            &.active {
                border: solid 3px var(--primary);
            }
            .color {
                width: 100%;
                height: 0;
                padding-bottom: 100%;
                background: var(--surface-4);
                margin-bottom: 10px;
            }
            .title {
                text-align: center;
                font-size: 1rem;
            }
            .subtitle {
                text-align: center;
                font-size: 0.8rem;
            }
        }
    }
    .colors.group1 {
        border-bottom: 1px solid var(--border-color-default);
    }
</style>
